import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { RmpvPassagemFiltroComponent } from './rmpv-passagem-filtro/rmpv-passagem-filtro.component';
import { RmpvPassagemListaComponent } from './rmpv-passagem-lista/rmpv-passagem-lista.component';
import { RmpvPassagemService } from './rmpv-passagem-service/rmpv-passagem.service';
import { RmpvPassagemComponent } from './rmpv-passagem.component';


@NgModule({
  imports: [
      HttpModule,
      FormsModule,
      CommonModule,
      BrowserModule,
      ReactiveFormsModule,
      ComumModule,
      ChartsModule,
      NgbModule,
      TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    RmpvPassagemComponent
  ],
  declarations: [
    RmpvPassagemComponent,
    RmpvPassagemListaComponent,
    RmpvPassagemFiltroComponent,
  ],
  providers: [
    RmpvPassagemService,
  ]
})
export class RmpvPassagemModule { }
